const sortAlphaNum = (a, b) => a.localeCompare(b, "en", { numeric: true });

export const sortAlphaNumericArr = (array) => {
  return array.sort(sortAlphaNum);
};
